import { SkuData, StyleIdData } from "../types/common.types";

export const flattenData = (data: StyleIdData): SkuData[] => {
  const { skus, images, ...rest } = data;

  return skus.map((sku) => ({
    ...rest,
    ...sku,
    image1: images[0] || "",
    image2: images[1] || "",
    image3: images[2] || "",
    image4: images[3] || "",
    skuId: sku.sku,
    measurementName1: sku.measurements.measurementName1,
    measurementName2: sku.measurements.measurementName2,
    measurementUnit1: sku.measurements.measurementUnit1,
    measurementUnit2: sku.measurements.measurementUnit2,
    measurementValue1: sku.measurements.measurementValue1,
    measurementValue2: sku.measurements.measurementValue2,
  }));
};
